<template>
    <div class="tw-mt-4 tw-border tw-border-solid tw-p-3 tw-border-gray-200 tw-rounded-lg">
        <div class="row l-meeting-goal-item-row">
            <!-- Goal Headline -->
            <div class="col-md-9 col-xs-12 tw-truncate">
                <span
                    class="fake-link clickable"
                    @click="toggleExpandKR()"
                    @keyup.enter="toggleExpandKR()"
                >
                    {{ goal.name }}
                </span>
                <br />
                <span class="color-grey">
                    {{ goal.contributionTag }}
                </span>
            </div>
            <!--/Goal Headline -->

            <!-- Goal Status -->
            <div class="col-md-3 hidden-xs">
                <span v-if="goal.status === 'draft'">
                    -
                </span>
                <span v-else> {{ goal.progress || 0 }}% </span>

                <span
                    v-if="goal.visibility === 'me'"
                    v-b-popover.hover.topright="{
                        content: $t('goals.update.optionVisibilityMe'),
                    }"
                >
                    <i
                        class="fal fa-eye-slash color-grey l-default-margin-s r-default-margin-s"
                    ></i>
                </span>

                <span class="pull-right">
                    <a
                        title="xx"
                        :href="`/app/#/goals/details/${goal._id}`"
                        target="_blank"
                        class="fake-link"
                        aria-label="link to open goal"
                    >
                        <i class="fal fa-external-link"></i>
                    </a>
                </span>

                <br />

                <span v-if="goal.toDiscuss">
                    <span
                        v-if="goal.toDiscuss === 'offTrack'"
                        v-b-popover.hover.topright="{
                            content: $t('goals.list.helpActiveOffTrack'),
                        }"
                        class="color-danger"
                    >
                        <i class="fal fa-remove"></i>
                    </span>
                    <span
                        v-else-if="goal.toDiscuss === 'inputNeeded'"
                        v-b-popover.hover.topright="{
                            content: $t('goals.list.helpActiveInputNeeded'),
                        }"
                        class="color-warning"
                    >
                        <i class="fal fa-warning"></i>
                    </span>
                    <span
                        v-else-if="goal.toDiscuss === 'onTrack'"
                        v-b-popover.hover.topright="{
                            content: $t('goals.list.helpActiveOnTrack'),
                        }"
                        class="color-success"
                    >
                        <i class="fal fa-check"></i>
                    </span>
                </span>
            </div>
            <!--/Goal Status -->
        </div>

        <!-- Expand KRs -->
        <div v-if="expandKR">
            <div class="hr-small" />
            <div
                v-for="keyResult in goal.keyResults"
                :key="keyResult._id"
                class="row tw-mb-4"
                @click="() => openEditKRModal(keyResult)"
                @keyup.enter="() => openEditKRModal(keyResult)"
            >
                <div
                    class="col-md-9 tw-truncate"
                    :class="{ 'fake-link clickable': keyResult.canUpdateKR }"
                >
                    {{ keyResult.name }}
                </div>
                <div class="col-md-3" :class="{ 'fake-link clickable': keyResult.canUpdateKR }">
                    <span v-if="keyResult.metricType !== 'none'">
                        {{ keyResult.metricCurrent }} / {{ keyResult.metricEnd }}
                    </span>
                </div>
            </div>
        </div>
        <!--/Expand KRs -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        goal: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            expandKR: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
        }),
    },
    methods: {
        toggleExpandKR() {
            this.expandKR = !this.expandKR;
        },
        openEditKRModal(keyResult) {
            if (!keyResult.canUpdateKR) {
                return;
            }
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    editGoalId: this.goal._id,
                    editKeyResultId: keyResult._id,
                },
            });
        },
    },
};
</script>
